
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { MdChevronRight, MdExpandMore } from "react-icons/md";
import DashIcon from "components/icons/DashIcon";

export function SidebarLinks(props) {
  const location = useLocation();
  const { routes } = props;
  const [openMenus, setOpenMenus] = useState({});

  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  const toggleMenu = (path) => {
    setOpenMenus((prev) => ({ ...prev, [path]: !prev[path] }));
  };

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (route.hidden) return null;

      if (!(route.layout === "/admin" || route.layout === "/auth" || route.layout === "/rtl")) return null;

      if (route.children) {
        const isExpanded = openMenus[route.path] ?? route.children.some((c) => activeRoute(c.path));

        return (
          <div key={index}>
            <div
              className="relative mb-3 flex hover:cursor-pointer"
              onClick={() => toggleMenu(route.path)}
            >
              <li className="my-[3px] flex cursor-pointer items-center px-8 w-full">
                <span
                  className={`${
                    route.children.some((c) => activeRoute(c.path))
                      ? "font-bold text-brand-500 dark:text-white"
                      : "font-medium text-gray-600"
                  }`}
                >
                  {route.icon ? route.icon : <DashIcon />}
                </span>
                <p
                  className={`leading-1 ml-4 flex flex-1 ${
                    route.children.some((c) => activeRoute(c.path))
                      ? "font-bold text-navy-700 dark:text-white"
                      : "font-medium text-gray-600"
                  }`}
                >
                  {route.name}
                </p>
                <span className="ml-auto pr-4 text-gray-400">
                  {isExpanded ? <MdExpandMore size={18} /> : <MdChevronRight size={18} />}
                </span>
              </li>
            </div>

            {isExpanded && (
              <div className="ml-6 border-l border-gray-200 dark:border-white/10 mb-2">
                {route.children.map((child, childIndex) => (
                  <Link key={childIndex} to={child.layout + "/" + child.path}>
                    <div className="relative mb-2 flex hover:cursor-pointer">
                      <li className="my-[3px] flex cursor-pointer items-center px-8">
                        <span
                          className={`${
                            activeRoute(child.path)
                              ? "font-bold text-brand-500 dark:text-white"
                              : "font-medium text-gray-400"
                          }`}
                        >
                          {child.icon ? child.icon : <DashIcon />}
                        </span>
                        <p
                          className={`leading-1 ml-4 flex text-sm ${
                            activeRoute(child.path)
                              ? "font-bold text-navy-700 dark:text-white"
                              : "font-medium text-gray-500"
                          }`}
                        >
                          {child.name}
                        </p>
                      </li>
                      {activeRoute(child.path) && (
                        <div className="absolute right-0 top-px h-8 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
                      )}
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        );
      }

      return (
        <Link key={index} to={route.layout + "/" + route.path}>
          <div className="relative mb-3 flex hover:cursor-pointer">
            <li className="my-[3px] flex cursor-pointer items-center px-8">
              <span
                className={`${
                  activeRoute(route.path)
                    ? "font-bold text-brand-500 dark:text-white"
                    : "font-medium text-gray-600"
                }`}
              >
                {route.icon ? route.icon : <DashIcon />}
              </span>
              <p
                className={`leading-1 ml-4 flex ${
                  activeRoute(route.path)
                    ? "font-bold text-navy-700 dark:text-white"
                    : "font-medium text-gray-600"
                }`}
              >
                {route.name}
              </p>
            </li>
            {activeRoute(route.path) && (
              <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
            )}
          </div>
        </Link>
      );
    });
  };

  return createLinks(routes);
}

export default SidebarLinks;